<template>
  <div class="relation">
    <vxe-table
      border
      show-overflow
      resizable
      :auto-resize="true"
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      :data="tableData"
      @cell-dblclick="dblclickEvent"
      :checkbox-config="{ checkMethod: checkMethod }"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="80" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :type="item.type"
        :key="index"
        :fixed="item.fixed"
        :field="item.prop"
        :title="item.label"
        :width="item.width"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot:edit="{ row }">
          <el-select
            v-model="row[item.prop]"
            @change="(val) => change(val, row)"
            clearable
            filterable
            :disabled="
              row.relatedMethod == '2' || contractStatus == 'ZT02' || contractStatus == 'ZT03'
            "
          >
            <el-option
              v-for="key in item.options"
              :key="key.value"
              :label="key.label"
              :value="key.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="scope">
          <template v-if="item.editRender">{{ scope.row.relationShipIdentityName }}</template>
          <template v-else>{{ scope.row[item.prop] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  export default {
    name: 'ProjectRelationInfo',
    props: {
      defaultData: {
        type: Array,
        default: () => [],
      },
      contractNo: {
        type: String,
        default: '',
      },
      contractStatus: {
        type: String,
        default: '',
      },
    },
    watch: {
      // 将默认值给表格数据
      defaultData: {
        handler() {
          this.checkRowKeys = this.defaultData.map((item) => {
            return item.relatedContractNo;
          });
          this.tableData = this.defaultData.slice();
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        tableData: [],
        checkRowKeys: [],
        relationshipDelIds: [],
        editConfig: {},
      };
    },
    computed: {
      // 表格展示数据
      columnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('contractAgency.relationTab.number'),
          },
          {
            prop: 'contractDetailCategoryName',
            label: this.$t('contractAgency.relationTab.type'),
          },
          {
            prop: 'contractCreateDate',
            label: this.$t('contractAgency.relationTab.createTime'),
          },
        ];
      },
    },
    created() {
      // this.extraData = {
      //   relationContractCategory:
      //     this.$route.query.contractCategory == 'sales' ? 'sales' : 'purchase',
      //   relationContractDetailCategory: this.$route.query.type,
      //   contractStatus: 'ZT03',
      // };
      // this.editConfig = this.isEdit ? {} : { trigger: 'click', mode: 'row', showStatus: true };
    },
    methods: {
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.xTable;
        return $table.getTableData().fullData;
      },
      //关联标识
      change(val, row) {
        if (val) {
          row.relationShipIdentityName =
            val == '0'
              ? this.$t('contractAgency.relationTab.before')
              : this.$t('contractAgency.relationTab.after');
        } else {
          row.relationShipIdentityName = '';
        }
      },
      confirm(multipleSelection) {
        let list = this.$refs.xTable.getTableData().fullData;
        multipleSelection.forEach((item) => {
          let flag = true;
          for (let i = 0; i < list.length; i++) {
            if (list[i].relatedContractNo == item.contractNo) {
              flag = false;
            }
          }
          if (flag) {
            // 给需要的值给表格展示
            list.push({
              relatedContractNo: item.contractNo,
              relatedContractType: item.contractDetailCategory,
              relatedContractTypeName: item.contractDetailCategoryName,
              relatedContractCreateDate: item.contractCreateDate,
              relationshipType: item.contractCategory,
              relationShipIdentity: item.relationShipIdentity,
              relationShipIdentityName: item.relationShipIdentityName,
            });
          }
        });
        this.tableData = this.filterArr(list.slice(), 'relatedContractNo');
        // 关闭弹窗
        this.$refs.relationInfo.dialogVisible = false;
      },
      //剔除同数据
      filterArr(arr, name) {
        let hash = {};
        return arr.reduce((ss, item) => {
          // reduce累计器, ss是具体满足条件后返回的数据, item是数组依次循环的每一项
          hash[item[name]] ? '' : (hash[item[name]] = true && ss.push(item));
          // 1、判断对象的键值是否存在
          return ss;
        }, []);
      },
      //自动关联的不允许删除
      checkMethod({ row }) {
        if (row.relatedMethod == '2') {
          return false;
        }
        return true;
      },
      dblclickEvent(val) {
        if (val.column.property == 'relationShipIdentity') {
          return;
        }
        const row = val.row;
        let path;
        //采购合同
        if (row.contractCategory == 'purchase') {
          path = {
            path: '/salePurchase/wumaoContractEdit',
            name: 'wumaoContractEdit',
            meta: {
              keepAlive: true,
              title: '采购合同编辑',
            },
            query: {
              // id: id,
              type: row.contractDetailCategory,
              contractNo: row.contractNo,
              isEdit: false,
              contractCategory: 'purchase',
            },
          };
        }
        //销售合同
        if (row.contractCategory == 'sales') {
          path = {
            path: '/salePurchase/wumaoSaleContractEdit',
            name: 'wumaoSaleContractEdit',
            meta: {
              keepAlive: true,
              title: '销售合同编辑',
            },
            query: {
              // id: id,
              type: row.contractDetailCategory,
              contractNo: row.contractNo,
              isEdit: false,
              contractCategory: 'sales',
            },
          };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 获取关联明细
      getValues() {
        return this.tableData.map((item) => {
          const result = Object.assign({}, item);
          if (this.contractNo) {
            result.contractNo = this.contractNo;
          }
          return result;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vxe-table-element {
    margin-top: 5px;
  }

  .relation {
    margin-bottom: 10px;
  }
</style>
